<template>
  <div>
    <ul id="tabs-swipe-demo" class="tabs center">
      <li class="tab col s3">
        <a
          :class="[this.$store.state.porcentaje != 100 ? 'active' : 'tabc']"
          href="#test-swipe-1"
          >Documentos</a
        >
        <!-- <a class="active, tabc" href="#test-swipe-1">Documentos</a> -->
      </li>
      <li class="tab col s3">
        <a
          href="#test-swipe-2"
          :class="[this.$store.state.porcentaje == 100 ? 'active' : 'tabc']"
          >Diagnóstico</a
        >
      </li>
      <li class="tab col s3">
        <a href="#test-swipe-3" class="tabc">Pago en línea</a>
      </li>
    </ul>
    <div id="test-swipe-1" class="col s12 container"><documentos /></div>
    <div id="test-swipe-2" class="col s12">
      <div class="container"><cuestionario /></div>
    </div>
    <div id="test-swipe-3" class="col s12 container center">
      <br /><br /><br />
      <a
        :href="
          'https://ofertaeducativa.ilce.edu.mx/index.php/component/pagoshonduraspos/?task=mispagos&correo=' +
          this.$store.state.datosC.correo
        "
        target="_blank"
        rel="noopener noreferrer"
        class="btn"
        >Ir a pagos en línea</a
      >
    </div>
  </div>
</template>
<script>
export default {
  components: {
    documentos: () =>
      import(/*webpackChunkName: "documentos"*/ "../components/documentos"),
    cuestionario: () =>
      import(/*webpackChunkName: "cuestionario"*/ "../components/cuestionario"),
  },
  mounted() {
    M.AutoInit();
  },
  async created() {
    await this.$store.dispatch("cargaInfo");
    console.log(this.$store.state.porcentaje);
  },
};
</script>
<style >
.tabc {
  color: blue !important;
}
.colora {
  color: blue !important;
}
</style>